/**
 * Order-size limits shared by the server cart, checkout quote, order creation and the web cart.
 * Android clients read the server cart, so they inherit these through the API.
 */
export const CART_MAX_QUANTITY_PER_ITEM = 50;
export const CART_MAX_DISTINCT_ITEMS = 200;
